module.exports = __webpack_public_path__ + "static/media/cross.f03602f9.png";